import { Link } from "react-router-dom";
import type { BlacklistEntry } from "@/types";

const metricMeta: { key: keyof BlacklistEntry["metrics"]; label: string }[] = [
  { key: "form", label: "状态" },
  { key: "defense", label: "防守" },
  { key: "discipline", label: "纪律" },
  { key: "efficiency", label: "效率" },
];

export function MetricBar({ value, label }: { value: number; label: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className="w-8 shrink-0 text-xs text-foreground-500">{label}</span>
      <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
        <span
          className="block h-full rounded-full bg-accent-500"
          style={{ width: `${Math.min(value, 100)}%` }}
        ></span>
      </span>
      <span className="w-7 shrink-0 text-right text-xs font-semibold text-foreground-700">{value}</span>
    </div>
  );
}

export function BlacklistRow({
  entry,
  showMetrics = true,
}: {
  entry: BlacklistEntry;
  showMetrics?: boolean;
}) {
  const rankTone =
    entry.rank === 1
      ? "bg-accent-500 text-background-50"
      : entry.rank <= 3
      ? "bg-accent-100 text-accent-800"
      : "bg-background-200 text-foreground-700";

  return (
    <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 sm:flex-row sm:items-center">
      <span
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-lg font-extrabold ${rankTone}`}
      >
        {entry.rank}
      </span>

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <h3 className="text-base font-bold text-foreground-950">{entry.name}</h3>
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
            {entry.team}
          </span>
        </div>
        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{entry.comment}</p>

        {showMetrics && (
          <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
            {metricMeta.map((m) => (
              <MetricBar key={m.key} label={m.label} value={entry.metrics[m.key]} />
            ))}
          </div>
        )}
      </div>

      <div className="flex shrink-0 flex-row items-center gap-4 sm:flex-col sm:items-end">
        <div className="text-right">
          <p className="text-xs text-foreground-500">mdrs 失分指数</p>
          <p className="text-xl font-extrabold text-accent-600">{entry.score.toFixed(1)}</p>
        </div>
        <Link
          to={`/detail/${entry.eventId}`}
          className="flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-100"
        >
          查看赛事
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}